"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation resetUserPassword($forgotPasswordCode: String!, $password: String!) {
    resetUserPassword(forgotPasswordCode: $forgotPasswordCode password: $password)
  }
`;
exports.default = mutation;
//# sourceMappingURL=resetUserPassword.mutation.js.map